import type { UnwrapSet } from '@/types'

export const PILL_GROUPS_SIZES = new Set(['default', 'lg'] as const)
export type PillGroupSize = UnwrapSet<typeof PILL_GROUPS_SIZES>
